import PageShell from "@/components/opsiq/PageShell";

const BLOCKS = [
  { h: "Our story", p: "OpsIQ was founded in Accra to close a gap we saw again and again in Ghanaian organisations: leaders drowning in data, starved of insight. We started as an in-house analytics team helping executives make sense of their operations. Today we're a consultancy building the Command Centres that leaders across Ghana and the region use to run modern organisations." },
  { h: "Vision", p: "To be Ghana's most trusted Operational Intelligence consultancy — the firm boards and CEOs turn to when they need to understand their business better and decide with confidence." },
  { h: "Mission", p: "To help every organisation we work with turn everyday data into decisions that improve performance, strengthen accountability, and grow the business." },
  { h: "Values", p: "Clarity over cleverness. Ownership over dependency. Simple to understand, professional to look at, useful every single day." },
  { h: "Brand promise", p: "We don't simply build dashboards. We build Operational Intelligence solutions that help organisations understand what is happening within their business, improve performance, and make decisions with confidence." },
];

export default function AboutPage() {
  return (
    <PageShell
      testid="about-page"
      eyebrow="About OpsIQ"
      title={<>Who we are, <span className="italic">why we exist.</span></>}
      subtitle="A Ghana-based Operational Intelligence consultancy building the Command Centres modern leaders rely on."
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 pb-16 md:pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {BLOCKS.map((b, i) => (
            <article key={b.h} data-testid={`about-block-${i}`} className="border border-white/10 bg-[#142645]/50 p-6 md:p-8">
              <div className="text-[10px] font-plex-mono uppercase tracking-[0.22em] text-[#D9FF3C] mb-3">0{i + 1}</div>
              <h2 className="font-editorial text-3xl md:text-4xl leading-tight tracking-tight text-[#F1ECE0] mb-4">{b.h}</h2>
              <p className="text-base text-[#F1ECE0]/75 leading-relaxed">{b.p}</p>
            </article>
          ))}
        </div>
      </div>
    </PageShell>
  );
}
